import { blog_commentConstants } from '../_constants';

export function blogcomments(state = {}, action) {
  switch (action.type) {
    case blog_commentConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case blog_commentConstants.GETALL_SUCCESS:
      return {
        items: action.blogcomments.data
      };
    case blog_commentConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    case blog_commentConstants.DELETE_REQUEST:
      // add 'deleting:true' property to post being deleted
      return {
        ...state,
        items: state.items.map(post =>
          post.id === action.id
            ? { ...post, deleting: true }
            : post
        )
      };
    case blog_commentConstants.DELETE_SUCCESS:
      // remove deleted post from state
      return {
        items: state.items.filter(post => post.id !== action.id)
      };
    case blog_commentConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to post
      return {
        ...state,
        items: state.items.map(post => {
          if (post.id === action.id) {
            // make copy of post without 'deleting:true' property
            const { deleting, ...postCopy } = post;
            // return copy of post with 'deleteError:[error]' property
            return { ...postCopy, deleteError: action.error };
          }

          return post;
        })
      };
    default:
      return state
  }
}


export function blogcomment(state = {}, action) {
  switch (action.type) {
    case blog_commentConstants.REGISTER_SUCCESS:
      return {
        item: action.blogcomment.data
      };
    case blog_commentConstants.GET_REQUEST:
      return {
        loading: true
      };
    case blog_commentConstants.GET_SUCCESS:
      return {
        item: action.blogcomment.data
      };
    case blog_commentConstants.GET_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}